import React from 'react';
import { render } from 'react-dom';
import '@atlaskit/css-reset';

import { favicon, logo } from 'assets';
import { indexHtmlDictionary } from 'indexHtmlDictionary';

import App from './App';

function initializeApp() {
  const { title } = indexHtmlDictionary;
  const head = document.querySelector('head');

  if (head) {
    const titleElement = document.createElement('title');
    const logoElement = document.createElement('link');
    const faviconElement = document.createElement('link');
    const metaElement = document.createElement('meta');

    titleElement.textContent = title;

    logoElement.rel = 'apple-touch-icon';
    logoElement.href = logo;

    faviconElement.rel = 'icon';
    faviconElement.href = favicon;

    metaElement.name = 'description';
    metaElement.content = title;

    [titleElement, logoElement, faviconElement, metaElement].forEach((e) =>
      document.head.appendChild(e),
    );
  }
}

initializeApp();

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
